import { HTTPStatusCode } from "@libs/api/types";
import {
  RequestCesSurveyType,
  SubmitCesSurveyResponseType,
} from "@/domain/cesSurveys";
import { sendSentryError } from "@/services/sentry";
import { tsRestClient } from "@/services/ts-rest";

export const CesSurveysApi = {
  requestCesSurvey: async (body: RequestCesSurveyType) => {
    const res = await tsRestClient().cesSurveys.requestCesSurvey({ body });

    if (res.status === HTTPStatusCode.CREATED) {
      return res.body;
    }

    // The patient was not sampled at this trigger point, so there is nothing
    // to prompt them with
    if (res.status === HTTPStatusCode.OK) {
      return null;
    }

    sendSentryError({
      message: "Unexpected response in CesSurveysApi.requestCesSurvey",
      error: res.body,
      shouldThrowError: true,
    });
  },

  submitCesSurveyResponse: async (
    id: string,
    data: SubmitCesSurveyResponseType,
  ) => {
    const res = await tsRestClient().cesSurveys.submitCesSurveyResponse({
      params: { id },
      body: data,
    });

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    sendSentryError({
      message: "Unexpected response in CesSurveysApi.submitCesSurveyResponse",
      error: res.body,
      shouldThrowError: true,
    });
  },
};
